export default {
    translation: {
      // header
      SelectLanguage: "Επιλέξτε Γλώσσα",
      Discover: "Ανακαλύψτε",
      WhyQriend: "Γιατί QRiend;",
      LeaveMark: "Αφήστε το Σημάδι σας",
      InstallNow: "Κατεβάστε Τώρα",
      Login: "Σύνδεση",
      Register: "Εγγραφή",
      LogOut: "Αποσύνδεση",
  
      // footer
      HomePage: "Αρχική Σελίδα",
      QriendDescFooter:
        "Ανακαλύψτε νέες φιλίες σε κοινωνικά περιβάλλοντα, γνωρίστε με ασφάλεια και σύγχρονο τρόπο!",
      Pages: "Σελίδες",
      PrivacyAndSecurity: "Απόρρητο και Ασφάλεια",
      QriendTeam: "Η Ομάδα μας",
      PrivacyPolicy: "Πολιτική Απορρήτου",
      TermsOfUse: "Όροι Χρήσης",
      DataSecurity: "Ασφάλεια Δεδομένων",
      CookiePolicy: "Πολιτική Cookies",
      AccountSecurity: "Ασφάλεια Λογαριασμού",
      LegalConsentAndDisclosureText: "Νομική Συναίνεση και Κείμενο Ενημέρωσης",
      ChildSafetyPolicy: "Πολιτική Ασφάλειας Παιδιών",
      PrivacySettingsGuide: "Πολιτική Ρυθμίσεων Απορρήτου",
      SuitableForAllDevices: "Συμβατό με όλες τις συσκευές",
      DownloadNowFooter: "Κατεβάστε τώρα, επεκτείνετε το κοινωνικό σας δίκτυο!",

      // delete request
      DeleteRequestTitle: "Αίτημα διαγραφής λογαριασμού",
      DeleteAccountQuestion: "Θέλετε να διαγράψετε τον λογαριασμό σας;",
      Username: "Όνομα χρήστη",
      Password: "Κωδικός πρόσβασης",
      DeleteReason: "Γιατί θέλετε να διαγράψετε τον λογαριασμό σας;",
      UsernamePlaceholder: "Εισάγετε το όνομα χρήστη σας",
      PasswordPlaceholder: "Εισάγετε τον κωδικό πρόσβασης σας",
      ReasonPlaceholder: "Εξηγήστε γιατί θέλετε να διαγράψετε τον λογαριασμό σας...",
      SubmitDeleteRequest: "Υποβολή αιτήματος διαγραφής",
      Warning: "Προειδοποίηση",
      WarningMessage: "Η διαγραφή του λογαριασμού δεν μπορεί να αναιρεθεί. Όλα τα δεδομένα σας θα διαγραφούν μόνιμα.",
      RequestSubmittedSuccessfully: "Το αίτημα υποβλήθηκε επιτυχώς",
      RequestSubmittedMessage: "Το αίτημα διαγραφής λογαριασμού σας έχει ληφθεί. Θα επικοινωνήσουμε μαζί σας το συντομότερο δυνατό.",
      SendNewRequest: "Αποστολή νέου αιτήματος",
      UsernameRequired: "Το όνομα χρήστη είναι υποχρεωτικό",
      PasswordRequired: "Ο κωδικός πρόσβασης είναι υποχρεωτικός",
      ReasonRequired: "Ο λόγος διαγραφής λογαριασμού είναι υποχρεωτικός",

    // register page
    createAccount: "Δημιουργία λογαριασμού",
    createAccountDesc: "Εγγραφείτε τώρα και ξεκινήστε να γνωρίζετε νέους ανθρώπους!",
    firstname: "Όνομα",
    lastname: "Επώνυμο",
    username: "Όνομα χρήστη",
    email: "Email",
    password: "Κωδικός πρόσβασης",
    gender: "Φύλο",
    male: "Άνδρας",
    female: "Γυναίκα",
    noGender: "Προτιμώ να μην το πω",
    registerMain: "Εγγραφή",
    registerDesc: "Έχετε ήδη λογαριασμό;",
    registerLogin: "Σύνδεση",
    kvkkConsent: "Αποδέχομαι τις συμφωνίες KVKK και απορρήτου",
    kvkkConsentRequired: "Πρέπει να αποδεχτείτε τις συμφωνίες KVKK και απορρήτου",
    privacyPolicy: "Πολιτική απορρήτου",
    termsOfUse: "Όροι χρήσης",

      // Landing Qriend Nedir?
      WhatIsQriend: "Τι είναι το QRiend;",
      WhatIsQriendDesc:
        "Σας επιτρέπει να γνωρίζετε ανθρώπους που βρίσκονται στον ίδιο χώρο με την τεχνολογία QR κώδικα. Προσφέρει μια σύγχρονη και ασφαλή πλατφόρμα για να γνωρίσετε νέους ανθρώπους σε κοινωνικούς χώρους όπως μπαρ, καφέ, εστιατόρια.",
      RealProfile: "Πραγματικό Προφίλ",
      RealProfileDesc:
        "Αλληλεπιδράτε μόνο με επαληθευμένους πραγματικούς χρήστες.",
      InstantMeetingOpportunity: "Άμεση Ευκαιρία Γνωριμίας",
      InstantMeetingOpportunityDesc:
        "Μπορείτε να γνωρίσετε άμεσα κάποιον που βλέπετε στον χώρο στέλνοντας μήνυμα.",
      VenueChats: "Συνομιλίες Χώρων",
      VenueChatsDesc:
        "Το QRiend προσφέρει δυνατότητα ψηφιακής κοινωνικοποίησης στον χώρο που βρίσκεστε.",
  
      // Landing Nasıl Tanışılır?
      HowtoMeet: "Πώς να Γνωρίσετε;",
      HowtoMeetDesc:
        "Χάρη στην εφαρμογή μας, η γνωριμία με ανθρώπους στον χώρο που βρίσκεστε σε πραγματικό χρόνο είναι πλέον πολύ εύκολη! Ιδού πώς να το χρησιμοποιήσετε βήμα προς βήμα;",
      EntryandConnectiontotheSpace: "Είσοδος και Σύνδεση στον Χώρο",
      EntryandConnectiontotheSpaceDesc: "Σαρώστε τον QR κώδικα με το τηλέφωνό σας",
      EntryandConnectiontotheSpaceDesc2:
        "Συνδεθείτε στην εφαρμογή και γίνετε μέλος του δικτύου του χώρου",
      InSituExploration: "Εξερεύνηση Μέσα στον Χώρο",
      InSituExplorationDesc: "Δείτε άλλους χρήστες που βρίσκονται στον χώρο εκείνη τη στιγμή",
      InSituExplorationDesc2: "Εξετάστε προφίλ που σας φαίνονται ενδιαφέροντα",
      CommunicationInitiation: "Έναρξη Επικοινωνίας",
      CommunicationInitiationDesc: "Στείλτε μήνυμα σε άτομα που τράβηξαν την προσοχή σας",
      CommunicationInitiationDesc2:
        "Επικοινωνήστε εύκολα με κάποιον που κάνατε οπτική επαφή",
      CommunicationInitiationDesc3: "Μπείτε στην ομαδική συνομιλία της τοποθεσίας σας",
      SafeSocialization: "Ασφαλής Κοινωνικοποίηση",
      SafeSocializationDesc: "Γνωρίστε ανταλλάσσοντας μηνύματα",
      SafeSocializationDesc2:
        "Μπορείτε να ελέγξετε ή να τερματίσετε τη συνομιλία όποτε θέλετε",
      SafeSocializationDesc3:
        "Συνεχίστε να γνωρίζετε νέους ανθρώπους με ευχάριστο και ασφαλή τρόπο",
  
      //   Uygulamayı İndir Bölümü
      DownloadApp: "ΚΑΤΕΒΑΣΤΕ ΤΗΝ ΕΦΑΡΜΟΓΗ &",
      DownloadApp2: "ΞΕΚΙΝΗΣΤΕ ΝΑ ΑΝΑΚΑΛΥΠΤΕΤΕ!",
      DownloadAppDesc: "Στο App Store και Google Play!",
      DownloadAppDesc2: "Κατεβάστε δωρεάν,",
      DownloadAppDesc3: "ανακαλύψτε premium χαρακτηριστικά.",
  
      // discover
      DiscoverTitle:
        "Καινοτόμος και Κοινωνική Πλατφόρμα που Διευκολύνει τις Πραγματικές Συναντήσεις",
      DiscoverDesc:
        "Βαρεθήκατε τις ατέλειωτες συνομιλίες; Δεν θα θέλατε να ξέρετε ότι βρίσκεστε στον ίδιο χώρο με ανθρώπους που θέλετε να γνωρίσετε στην πραγματική ζωή; Ακριβώς γι' αυτό η εφαρμογή μας είναι διαφορετική!",
      DiscoverEp2:
        "Είστε έτοιμοι να αποκτήσετε την ευκαιρία να γνωρίσετε πραγματικούς ανθρώπους στον ίδιο χώρο επιβεβαιώνοντας την παρουσία σας με τεχνολογία QR κώδικα στους συνεργαζόμενους χώρους μας;",
      DiscoverEp2Dot: "Παρακολούθηση Φιλίας",
      DiscoverEp2DotDesc:
        "Ακολουθήστε προφίλ που σας αρέσουν και ανακαλύψτε τους χώρους που προτιμούν. Αποκτήστε την ευκαιρία να γνωρίσετε νέους χώρους και νέους ανθρώπους.",
      DiscoverEp3Dot: "Likes Προφίλ και Χώρων",
      DiscoverEp3DotDesc:
        "Γνωρίστε νέους ανθρώπους μέσω των προφίλ και χώρων που σας αρέσουν, ανακαλύψτε αγαπημένους χώρους.",
      DiscoverEp4Dot: "Γνωριμία στον Χώρο",
      DiscoverEp4DotDesc:
        "Αντίθετα με τις συνηθισμένες εφαρμογές γνωριμιών, στην δική μας όλα είναι πραγματικά! Μπορείτε να δείτε ότι βρίσκεστε στον ίδιο χώρο με κάποιον που σας αρέσει και να γνωριστείτε αμέσως.",
      SwiperText: "Βολική Διεπαφή",
  
      SafetyMeet: "Πιο Ασφαλείς και Διασκεδαστικές Γνωριμίες",
      RealTimeInteraction: "Αλληλεπίδραση Πραγματικού Χρόνου",
      RealTimeInteractionDesc:
        "Αντί να χάνεστε στον εικονικό κόσμο, γνωρίστε ανθρώπους που όντως βρίσκονται στον ίδιο χώρο τώρα",
      RealTimeInteractionDesc2:
        "Ποιος είναι στο αγαπημένο σας καφέ; Δείτε άμεσα και μην χάσετε την ευκαιρία γνωριμίας",
      RealTimeInteractionDesc3:
        "Χάρη στην τεχνολογία QR κώδικα μας, επιβεβαιώστε εύκολα τον χώρο που βρίσκεστε",
      SecureAndVerifiedEnvironment: "Ασφαλές και Επαληθευμένο Περιβάλλον",
      SecureAndVerifiedEnvironmentDesc: "Κοινωνικοποιηθείτε στους συνεργαζόμενους χώρους μας",
      SecureAndVerifiedEnvironmentDesc2:
        "Ο κίνδυνος ψεύτικων προφίλ είναι ελάχιστος χάρη στην πραγματική επαλήθευση τοποθεσίας",
      SecureAndVerifiedEnvironmentDesc3:
        "Ανακαλύψτε και μοιραστείτε αγαπημένους χώρους",
      BenefitsForBusinesses: "Πλεονεκτήματα για Επιχειρήσεις",
      BenefitsForBusinessesDesc: "Αυξήστε τη ροή πελατών",
      BenefitsForBusinessesDesc2: "Δημιουργήστε περιβάλλον με υψηλή κοινωνική αλληλεπίδραση",
  
      // leave-mark
      LeaveMark: "Αφήστε το Σημάδι σας",
      LeaveMarkTitle:
        "Αφήστε το Σημάδι σας: Επεκτείνετε την Κοινωνική σας Εμπειρία, Δημιουργήστε Συνδέσεις σε Εκδηλώσεις",
      LeaveMarkDesc:
        "Η δυνατότητα 'Αφήστε το Σημάδι σας' του QRiend σας επιτρέπει να επεκτείνετε την κοινωνική σας εμπειρία σε συναυλίες, φεστιβάλ, συνέδρια και πολλές άλλες εκδηλώσεις. Τώρα μπορείτε να γνωρίσετε νέους ανθρώπους όχι μόνο σε χώρους, αλλά σε κάθε εκδήλωση που παρακολουθείτε.",
      How2Use: "Πώς Λειτουργεί;",
      How2UseDot1: "Συμμετοχή στην Εκδήλωση",
      How2UseDot1Desc:
        "Πηγαίνετε σε συναυλία, φεστιβάλ, συνέδριο ή οποιαδήποτε εκδήλωση",
      How2UseDot1Desc2: "Σαρώστε τον ειδικό QR κώδικα QRiend στον χώρο εκδήλωσης",
      How2UseDot1Desc3: "Συνδεθείτε άμεσα στο chat εκδήλωσης",
      How2UseDot2: "Ανακάλυψη Συμμετεχόντων Εκδήλωσης",
      How2UseDot2Desc:
        "Δείτε άλλους χρήστες QRiend που συμμετέχουν στην ίδια εκδήλωση",
      How2UseDot2Desc2:
        "Παρακολουθήστε σε πραγματικό χρόνο πόσοι άνθρωποι είναι ενεργοί στο chat εκδήλωσης",
      How2UseDot2Desc3: "Βρείτε άτομα με κοινά ενδιαφέροντα",
      How2UseDot3: "Ειδικές Αλληλεπιδράσεις",
      How2UseDot3Desc:
        "Μπορείτε να στείλετε ειδικά emoji σε συμμετέχοντες που τράβηξαν την προσοχή σας",
      How2UseDot3Desc2:
        "Τα emoji που στέλνονται είναι ορατά σε όλο το chat ως 'Ο Χρήστης A έστειλε emoji καρδιά στον Χρήστη B'",
      How2UseDot3Desc3:
        "Η αποστολή emoji είναι premium χαρακτηριστικό και κάνει τη γνωριμία σε εκδηλώσεις πιο διασκεδαστική",
      WhereCanIUseIt: "Πού Μπορώ να το Χρησιμοποιήσω;",
      WhereCanIUseItDesc:
        "Ο πιο εύκολος τρόπος να γνωρίσετε νέους ανθρώπους σε διαφορετικά περιβάλλοντα από καφέ έως συναυλίες, από φεστιβάλ έως εστιατόρια.",
      WhereCanIUseItDot1: "Αφήστε το Σημάδι σας σε Συναυλίες",
      WhereCanIUseItDot1Desc:
        "Γράψτε κάτι που θα αφήσει το σημάδι σας στη συναυλία που παρακολουθείτε.",
      WhereCanIUseItDot2: "Αφήστε το Σημάδι σας σε Καφέ",
      WhereCanIUseItDot2Desc:
        "Δυνατότητα κοινωνικοποίησης σε ευρείς φιλικούς κύκλους σε καφέ ή pubs",
      WhereCanIUseItDot3: "Χρήση σε Μπαρ και Νυχτερινά Κλαμπ",
      WhereCanIUseItDot3Desc:
        "Κοινωνικοποίηση στη νυχτερινή ζωή, θεματικές βραδιές και ευκαιρίες ασφαλών γνωριμιών",
      DownloadApp: "Κατεβάστε την Κινητή Εφαρμογή και Αφήστε το Σημάδι σας",
  
      // downloadPage
      DownloadNowNew: "Κατεβάστε Τώρα και Ξεκινήστε",
      DownloadNowNew2: "να Γνωρίζετε Νέους",
      DownloadNowNew3: "Ανθρώπους!",
      DownloadNowDesc:
        "Σε κάθε χώρο που πηγαίνετε, γνωρίστε νέους ανθρώπους με έναν μόνο QR!",
      SupportPlatforms: "Υποστηριζόμενες Πλατφόρμες και Συσκευές",
      SupportPlatformsDesc: "Δυνατότητα Πρόσβασης από Παντού",
      SupportPlatformsDesc2: "Κινητές Συσκευές",
      SupportPlatformsDescDot:
        "Εφαρμογή iOS (βελτιστοποιημένη για iPhone και iPad)",
      SupportPlatformsDescDot2:
        "Εφαρμογή Android (Όλα τα τηλέφωνα και tablets Android)",
  
      // login ve register
      welcome: "Καλώς Ήρθατε",
      welcomeDesc:
        "Μας λείψατε! Παρακαλώ συνδεθείτε για να καλύψετε όσα χάσατε.",
      email: "E-Mail",
      password: "Κωδικός",
      forgotPassword: "Ξεχάσατε τον κωδικό σας;",
      login: "Σύνδεση",
      registerMain: "Εγγραφή",
      loginDesc: "Δεν έχετε ακόμα λογαριασμό; Αμέσως",
      loginReg: "εγγραφείτε",
      createAccount: "Δημιουργία Λογαριασμού",
      createAccountDesc: "Εγγραφείτε τώρα, αρχίστε να δημιουργείτε νέες φιλίες.",
      firstname: "Όνομα",
      lastname: "Επώνυμο",
      username: "Όνομα Χρήστη",
      gender: "Φύλο",
      password: "Κωδικός (Τουλάχιστον 6 χαρακτήρες)",
      register: "Εγγραφή",
      registerDesc: "Έχετε λογαριασμό; Αμέσως",
      registerLogin: "Συνδεθείτε",
      rememberMe: "Να με θυμάστε",
      male: "Άνδρας",
      female: "Γυναίκα",
      noGender: "Δεν θέλω να δηλώσω φύλο",
  
      // Şifre Sıfırlama - forgotPassword.js
      resetPassword: "Ανανεώστε τον Κωδικό σας",
      resetPasswordDesc: "Παρακαλώ εισάγετε τη διεύθυνση email σας για να ζητήσετε επαναφορά κωδικού.",
      emailPlaceholder: "...@qriend.app",
      sending: "Αποστολή...",
      send: "Αποστολή",
      userNotFoundError: "Δεν βρέθηκε χρήστης με αυτή τη διεύθυνση email.",
      generalError: "Παρουσιάστηκε σφάλμα, παρακαλώ δοκιμάστε ξανά.",
      checkSpamFolder: "*Μην ξεχάσετε να ελέγξετε τον φάκελο spam.",
  
      // Şifre Sıfırlama Onay - forgotPasswordConfirm.js
      passwordReset: "Επαναφορά Κωδικού",
      passwordResetDesc: "Εισάγετε τον 6ψήφιο κωδικό που στάλθηκε στο email σας και δημιουργήστε νέο κωδικό.",
      verificationCode: "Κωδικός Επαλήθευσης",
      codeValidityTime: "Χρόνος ισχύος κωδικού",
      newPassword: "Νέος Κωδικός",
      newPasswordPlaceholder: "Εισάγετε νέο κωδικό",
      confirmPassword: "Επιβεβαίωση Κωδικού",
      confirmPasswordPlaceholder: "Επιβεβαιώστε τον κωδικό σας",
      resettingPassword: "Επαναφορά Κωδικού...",
      resetPasswordButton: "Επαναφορά Κωδικού",
      enterVerificationCode: "Εισάγετε τον 6ψήφιο κωδικό επαλήθευσης.",
      passwordMinLength: "Ο κωδικός πρέπει να έχει τουλάχιστον 6 χαρακτήρες.",
      passwordMismatch: "Οι κωδικοί δεν ταιριάζουν!",
      passwordResetSuccess: "Ο κωδικός σας επαναφέρθηκε με επιτυχία!",
      passwordResetError: "Δεν ήταν δυνατή η επαναφορά κωδικού, παρακαλώ δοκιμάστε ξανά.",
    },
  };